<template>
	<div class="tabs" :class="containerClass">
		<div class="tabs__head" :class="tabsHeadClass">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		activeTab: {
			type: String,
			default: ''
		},
		containerClass: {
			type: String,
			default: ''
		},
		tabsHeadClass: {
			type: String,
			default: ''
		},
		tabsBodyClass: {
			type: String,
			default: ''
		}
	},

	emits: ['change', 'update:activeTab'],
	
	data() {
		return {
			localActiveTab: this.activeTab
		};
	},

	watch: {
		activeTab(newVal) {
			this.localActiveTab = newVal;
		},

		localActiveTab(newVal) {
			this.$emit('update:activeTab', newVal);
			this.$emit('change', newVal);
		}
	},

	mounted() {
		if (!this.localActiveTab) {
			this.localActiveTab = '';
		}
	},

	methods: {
		open(tabId) {
			this.localActiveTab = tabId;
		}
	}
};
</script>
